export default "__VITE_ASSET__CARsIuvK__"